import { render, staticRenderFns } from "./BlogTemplate.vue?vue&type=template&id=91271d4c&scoped=true"
import script from "./BlogTemplate.vue?vue&type=script&lang=js"
export * from "./BlogTemplate.vue?vue&type=script&lang=js"
import style0 from "./BlogTemplate.vue?vue&type=style&index=0&id=91271d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91271d4c",
  null
  
)

export default component.exports